import { FormField, Select } from '@cian/ui-kit';
import React from 'react';
import { type IField } from '../../types/calculator';
import { getFieldPlaceholder } from '../../utils/getFieldPlaceholder';
import { useBaseField } from '../BaseField';

export const SelectField: React.FC<IField> = props => {
  const { field, fieldState } = useBaseField(props);

  const isError = fieldState.isDirty || fieldState.invalid;
  const selectValue = field.value == null || field.value === '' ? undefined : String(field.value);

  return (
    <FormField
      label={props.label}
      errorMessage={isError ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <Select
        data-testid={field.name}
        options={props.source || []}
        value={selectValue}
        onChange={field.onChange}
        placeholder={getFieldPlaceholder(props.placeholder)}
        invalid={Boolean(isError && fieldState.error)}
        name={field.name}
        ref={field.ref}
        disabled={props.disabled}
        size="M"
      />
    </FormField>
  );
};

SelectField.displayName = 'SelectField';
